import type { InternalAxiosRequestConfig } from "axios";
import { keycloak } from "../auth/keycloak";
import { getToken } from "../services/storageService";
import { isJwtExpired } from "../utils/jwt";

/** Prefer live Keycloak session token, then persisted gateway access token. */
export function resolveAccessToken(): string | null {
  if (keycloak.authenticated && keycloak.token && !isJwtExpired(keycloak.token)) {
    return keycloak.token;
  }
  return getToken();
}

export function bearerAuthHeaders(
  base: Record<string, string> = {},
): Record<string, string> {
  const token = resolveAccessToken();
  if (!token) return base;
  return { ...base, Authorization: `Bearer ${token}` };
}

export function attachBearerToken(
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
  config.headers = config.headers ?? {};
  if (!config.headers.Authorization) {
    const token = resolveAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
}

/** fetch() wrapper that always sends the Keycloak / gateway Bearer token. */
export async function authenticatedFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const headers = new Headers(init?.headers);
  if (!headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const token = resolveAccessToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  return fetch(input, {
    ...init,
    credentials: init?.credentials ?? "omit",
    headers,
  });
}
